export function openDialogForm() {
  return {
    type: '@dialogform/OPEN',
  };
}

export function closeDialogForm() {
  return {
    type: '@dialogform/CLOSE',
  };
}
